import './coupon.scss';

import { Outlet } from "react-router-dom";

import { FilterCouponProvider } from "./filter-coupon/filter-coupon.context";

export function Coupon() {
  return (
    <div id="ShellCoupon" className="coupon">
       <FilterCouponProvider>
        <Outlet />
      </FilterCouponProvider>
    </div>
  );
}

export default Coupon;
